import type { ZealApiResponse } from "@zeal/common";
import type { ICreateCompanyRequestBody } from "./ICreateCompanyRequestBody.jsonschema";
import type { ICreateCompanyResponseBody } from "./ICreateCompanyResponseBody.jsonschema";
import type { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { returnZealApiErrorResponse } from "../../returnZealApiErrorResponse";

const PATH = "/companies";

type CreateCompanyResponse = ZealApiResponse<ICreateCompanyResponseBody>;

export const createCompany =
  (axios: IAxiosInstance) => async (body: ICreateCompanyRequestBody) => {
    try {
      const response = await axios.noRetry.post<CreateCompanyResponse>(
        PATH,
        body
      );
      return response.data;
    } catch (err) {
      return returnZealApiErrorResponse(err);
    }
  };
